/* Prime Mode UI — language modal + product size-guide modal. No dependencies. */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
  var lastTrigger = null;
  var scrollLocks = 0;

  function lockScroll() {
    if (scrollLocks++ === 0) document.documentElement.style.overflow = 'hidden';
  }
  function unlockScroll() {
    if (--scrollLocks <= 0) { scrollLocks = 0; document.documentElement.style.overflow = ''; }
  }

  function openModal(modal, trigger) {
    if (!modal || modal.classList.contains('is-open')) return;
    lastTrigger = trigger || null;
    modal.hidden = false;
    lockScroll();
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var first = modal.querySelector('[data-pm-autofocus]') || modal.querySelector(FOCUSABLE);
    if (first) first.focus({ preventScroll: true });
  }

  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    unlockScroll();
    var done = function () {
      modal.hidden = true;
      modal.removeEventListener('transitionend', done);
    };
    var dialog = modal.querySelector('.pm-modal__dialog');
    if (dialog && window.getComputedStyle(dialog).transitionDuration !== '0s') {
      modal.addEventListener('transitionend', done);
      setTimeout(done, 500);
    } else { done(); }
    document.querySelectorAll('[aria-expanded="true"][data-pm-modal-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (lastTrigger) { try { lastTrigger.focus({ preventScroll: true }); } catch (e) {} lastTrigger = null; }
  }

  function trapFocus(e, modal) {
    if (e.key !== 'Tab') return;
    var nodes = Array.prototype.filter.call(modal.querySelectorAll(FOCUSABLE), function (n) {
      return n.offsetParent !== null;
    });
    if (!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pm-modal-open]');
    if (opener) {
      var modal = document.getElementById(opener.getAttribute('data-pm-modal-open'));
      if (modal) { e.preventDefault(); openModal(modal, opener); }
      return;
    }
    var closer = e.target.closest('[data-pm-modal-close]');
    if (closer) { e.preventDefault(); closeModal(closer.closest('.pm-modal')); }
  });

  document.addEventListener('keydown', function (e) {
    var open = document.querySelector('.pm-modal.is-open');
    if (!open) return;
    if (e.key === 'Escape') { e.preventDefault(); closeModal(open); return; }
    trapFocus(e, open);
  });

  /* --- Language selection --------------------------------------------- */
  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-pm-locale]');
    if (!pick) return;
    e.preventDefault();
    var form = pick.closest('form');
    if (!form) return;
    var input = form.querySelector('[data-pm-locale-input]');
    if (input) input.value = pick.getAttribute('data-pm-locale');
    form.submit();
  });

  /* --- Size guide ------------------------------------------------------ */
  function headingText(el) {
    return (el.textContent || '').trim().toLowerCase().replace(/[:.]\s*$/, '');
  }

  function buildSizeGuide() {
    var modal = document.getElementById('pm-sizeguide-modal');
    var trigger = document.querySelector('[data-pm-sizeguide]');
    if (!modal || !trigger) return;
    var body = modal.querySelector('[data-pm-sizeguide-body]');
    var desc = document.querySelector('.m-product-description');
    if (!desc || !body) { trigger.hidden = true; return; }

    var table = desc.querySelector('table');
    if (table) {
      var wrap = document.createElement('div');
      wrap.className = 'pm-sizeguide__scroll';
      wrap.appendChild(table.cloneNode(true));
      body.appendChild(wrap);
      return;
    }

    // No chart: surface the honest sizing note if the description carries one.
    var labels = ['sizing', 'maatvoering'];
    var nodes = Array.prototype.slice.call(desc.children);
    var start = -1;
    for (var i = 0; i < nodes.length; i++) {
      var strong = nodes[i].querySelector ? nodes[i].querySelector('strong') : null;
      var t = strong ? headingText(strong) : '';
      if (t && labels.indexOf(t) !== -1) { start = i; break; }
    }
    if (start === -1) { trigger.hidden = true; return; }
    for (var j = start + 1; j < nodes.length; j++) {
      if (nodes[j].querySelector && nodes[j].querySelector('strong')) break;
      body.appendChild(nodes[j].cloneNode(true));
    }
    if (!body.children.length) { trigger.hidden = true; return; }
    // The standing note describes a measurement table; drop it when we fall back to prose.
    var note = modal.querySelector('.pm-sizeguide__note');
    if (note) note.remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildSizeGuide);
  } else { buildSizeGuide(); }
})();
